// extracted by mini-css-extract-plugin
export default {"search-box":"Customers_search-box__pPJrN","mui-auto-fill-cancel":"Customers_mui-auto-fill-cancel__Eh59z"};